import useResizeObserver from "@react-hook/resize-observer";
import React, { useMemo, useState } from "react";
import shortid from "shortid";
import styled from "styled-components";

import { Button, FlexBox, PaneLayout, Toolbar } from "@examspark/common-ui";
import {
  IconPageNextLine,
  IconPagePreviousLine,
} from "@examspark/common-ui/dist/components/icons";
import { ExamSessionMetadata } from "@examspark/types";

import ItemPreview from "../../../items/ItemPreview";

const PreviewToolbar = styled.div`
  padding: 1rem;
  background-color: #f7f7f7;
  border-bottom: solid 1px #ddd;
  display: flex;
`;
const PreviewToolbarToggles = styled.div`
  flex: 1;
`;
const PreviewToolbarNav = styled(FlexBox)`
  gap: 0.5rem;
  justify-content: flex-end;
`;

const PreviewMain = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const ItemPickerPreview = (props: {
  itemId?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  onClose?: () => void;
}) => {
  const [size, setSize] = useState<DOMRectReadOnly>();
  const itemPreviewRef = React.useRef<React.ElementRef<"div">>(null);

  useResizeObserver(itemPreviewRef, (entry) => {
    setSize(entry.contentRect);
  });

  const sessionData: ExamSessionMetadata = useMemo(
    () => ({
      shuffleSeed: shortid.generate(),
      shuffleOptions: true,
      shuffleItems: false,
    }),
    [],
  );
  if (!props.itemId) return null;

  return (
    <PaneLayout direction="vertical">
      <PreviewToolbar>
        <PreviewToolbarToggles>
          <Toolbar>
            <Button
              title=""
              variant="outlined"
              disabled
              // disabled={
              //   results &&
              //   results?.findIndex((psg) => psg.id === preview.id) === 0
              // }
              onClick={() => {}}
              icon={<IconPagePreviousLine />}
            />

            <Button
              title=""
              variant="outlined"
              disabled
              // disabled={
              //   results &&
              //   results?.findIndex((psg) => psg.id === preview.id) ===
              //     results.length - 1
              // }
              onClick={() => {}}
              icon={<IconPageNextLine />}
            />
          </Toolbar>
        </PreviewToolbarToggles>
        <PreviewToolbarNav>
          <Button title="" variant="outlined" onClick={props.onClose}>
            Close Preview
          </Button>
        </PreviewToolbarNav>
      </PreviewToolbar>
      <PreviewMain>
        <ItemPreview
          condensed={
            size?.width === undefined || size.width < 600 ? true : false
          }
          sessionData={sessionData}
          itemId={props.itemId}
          showAutoRevealKey
        />
      </PreviewMain>
    </PaneLayout>
  );
};

export default ItemPickerPreview;
